import { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import { Border } from "@insite/mobius/Swatch";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { focusStyles } from "@store/Themes/common/mixins/common";
import { css } from "styled-components";

export const swatchItemSpacing = pxToRem(8);

export interface SwatchProps {
    wrapper?: InjectableCss;
    clickable?: ClickablePresentationProps;
    caption?: InjectableCss;
    label?: TypographyPresentationProps;
}

export const swatchProps: SwatchProps = {
    wrapper: {
        css: css`
            width: 100%;
        `,
    },
    label: {
        css: css`
            display: block;
            cursor: default;

            ${({ theme }) => {
                return css`
                    margin-bottom: ${pxToRem(sizeVariantValues.default.descriptionLineSpacing)};
                    line-height: ${(sizeVariantValues as any).default.descriptionLineHeight};
                    font-weight: ${theme.design.typography.weight.bold};
                `;
            }}
        `,
    },
    clickable: {
        css: css`
            ${focusStyles()}
            max-width: 100%;

            &:disabled {
                color: ${getColor("text.disabled")};
            }

            &:hover:not(:disabled) {
                ${Border} {
                    border-color: ${getColor("swatch.hover")};
                }

                &[data-selected] {
                    ${Border} {
                        border-color: ${getColor("swatch.selectedHover")};
                    }
                }
            }
        `,
    },
    caption: {
        css: css`
            margin-left: ${pxToRem(10)};
            max-width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `,
    },
};
